"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var List_1 = require("material-ui/List");
var lodash_1 = require("lodash");
var IconButton_1 = __importDefault(require("material-ui/IconButton"));
var expand_more_1 = __importDefault(require("material-ui/svg-icons/navigation/expand-more"));
var renderSidebarItem = lodash_1.curry(function (handleClick, isActive, activeItem, itemStyle, item, toggleItem) {
    var hasChildren = item.children && item.children.length > 0;
    var style = isActive(item.path) ? activeItem : itemStyle;
    var icon = (react_1.default.createElement(IconButton_1.default, { style: {
            top: 0,
            right: 0,
            transform: "rotateX(" + (!item.open ? 0 : 180) + "deg)",
        }, onClick: function (e) { return toggleItem(e, item.id); } },
        react_1.default.createElement(expand_more_1.default, { color: "white" })));
    return (react_1.default.createElement(List_1.ListItem, __assign({ onMouseDown: handleClick(item), key: item.id, style: __assign({}, style, { borderRight: item.withBorderRight ? '2px solid currentColor' : 0 }), primaryText: item.primaryText, open: item.open, rightToggle: hasChildren ? icon : null, nestedItems: hasChildren
            ? item.children.map(function (child) {
                return renderSidebarItem(handleClick, isActive, activeItem, itemStyle, child, toggleItem);
            })
            : undefined }, item.listItemProps)));
});
exports.default = renderSidebarItem;
//# sourceMappingURL=SidebarItem.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/Sidebar/SidebarItem.js
// module id = 1868
// module chunks = 0